import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    TextField,
    Chip
  } from "@mui/material";
  import React, { Dispatch, SetStateAction, useState } from "react";
import { CuisineDishService } from "../../services/CuisineDishService";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { CustomSnackbarTypes } from "./CustomSnackBar";
import { CouponService } from "../../services/CouponService";
import moment from "moment";
  
  interface InputProps {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    data: any;
  }
  
  let couponService = new CouponService()
  let cuisineService = new CuisineDishService();
  const UpdateSalesOwnerDialog = (props: InputProps) => {
    const [previewUrls, setPreviewUrls] = useState<string[]>([]);
    const [imageUrls, setImageUrls] = useState<string[]>([]);
    const [links, setLinks] = useState<string[]>([]);
    const [currentLink, setCurrentLink] = useState(""); 
  
    const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files) return;
      
        const selectedFiles = Array.from(e.target.files);
      
        const newPreviewUrls: string[] = [];
        const uploadedUrls: string[] = [];
        let index = 0;
      
        for (const file of selectedFiles) {
          try {
            // Create local preview
            const preview = URL.createObjectURL(file);
            newPreviewUrls.push(preview);
      
            // Get AWS signed URLs (per file)
            const res = await couponService.getAWSLinks(
              `${(props?.data?.id + '').replace(/\s/g, "").trim()}_${moment().format("YYYYMMDD_HHmmss")}${index++}`
            );
      
            const putUrl = res?.putUrl;
            const getUrl = res?.getUrl;
      
            // Upload to AWS
            await cuisineService.uploadImageToAWS(putUrl, file);
      
            uploadedUrls.push(getUrl);
      
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
              message: `Image ${file.name} uploaded successfully`,
              type: CustomSnackbarTypes.SUCCESS,
            });
          } catch (err) {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
              message: `Failed to upload ${file.name}`,
              type: CustomSnackbarTypes.ERROR,
            });
          }
        }
      
        // Update state after all uploads
        setPreviewUrls((prev) => [...prev, ...newPreviewUrls]); // add previews
        setImageUrls((prev) => [...prev, ...uploadedUrls]); // array of uploaded AWS URLs
      };
      
  
    const handleSubmit = () => {
      couponService.updateComboSalesOwner(props?.data?.id, {
        callLogs: links,
        imageUrls: imageUrls
      }).then(() => {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Updated Successfully",
          type: CustomSnackbarTypes.SUCCESS,
        });
        props.setOpen(false);
        window.location.reload();
      }).catch((err) => {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Update Failed",
          type: CustomSnackbarTypes.ERROR,
        });
      });
      // your logic
    };
  
    return (
      <Dialog open={props.open} scroll="paper" fullWidth maxWidth="sm">
        <DialogTitle>Please fill the required details</DialogTitle>
  
        <DialogContent>
          {/* Upload multiple images */}
          <FormControl fullWidth margin="normal">
            <Button variant="outlined" component="label">
              Upload Images
              <input
                type="file"
                accept="image/*"
                multiple
                hidden
                onChange={handleImageUpload}
              />
            </Button>
          </FormControl>
  
          {/* Image Preview Section */}
          {previewUrls.length > 0 && (
            <div
              style={{
                display: "flex",
                gap: "10px",
                flexWrap: "wrap",
                marginTop: 12
              }}
            >
              {previewUrls.map((url, idx) => (
                <img
                  key={idx}
                  src={url}
                  alt="preview"
                  style={{
                    width: 100,
                    height: 100,
                    objectFit: "cover",
                    borderRadius: 6,
                    border: "1px solid #ccc"
                  }}
                />
              ))}
            </div>
          )}
  
          {/* Comma-separated links input */}
          <FormControl fullWidth margin="normal">
            <TextField
              label="Enter link and press Add"
              value={currentLink}
              onChange={(e) => setCurrentLink(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  if (currentLink.trim()) {
                    setLinks(prev => [...prev, currentLink.trim()]);
                    setCurrentLink("");
                  }
                }
              }}
            />

            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 8 }}>
              {links.map((link, i) => (
                <Chip
                  key={i}
                  label={link}
                  onDelete={() => setLinks(prev => prev.filter((_, idx) => idx !== i))}
                />
              ))}
            </div>
          </FormControl>
        </DialogContent>
  
        <DialogActions>
          <Button
            variant="contained"
            color="success"
            onClick={handleSubmit}
            size="large"
          >
            Submit
          </Button>
  
          <Button
            variant="contained"
            color="error"
            onClick={() => props.setOpen(false)}
            size="large"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default UpdateSalesOwnerDialog;
  